@if (shown()) {
  <div class="empty-wrapper">
    <i class="aw-2-icn aw-2-icn--xl" aria-hidden="true" [awIcon]="icon()"></i>
    <p>{{ text() }}</p>
  </div>
}
